module.exports = __webpack_public_path__ + "img/horizontal_6_4_pp1_7016.c4bcf1fd.png";